import React from 'react';
import {Button, Divider} from 'semantic-ui-react';

import spaceman from 'Assets/images/error/spaceman.svg';
import bubbles from 'Assets/images/error/bubbles.svg';
import gradient from 'Assets/images/error/gradient.svg';

import './errorDisplay.scss';

export default ({error, title}) => {
  return (
    <div className="error-full-page">
      <img
        className="error-background"
        src={gradient}
        style={{objectFit: 'cover'}}
      />

      <img className="error-background" src={bubbles} />

      <img className="spaceman" src={spaceman} style={{right: -175}} />

      <div className="mhd--centered">
        <div className="error-text error-header">{title}</div>

        {error && (
          <div className="error-text error-blurb">{error.toString()}</div>
        )}

        <div className="error-text error-blurb">
          Call 888-558-6275 for support.
          <Divider hidden />
          <a href="http://forum.mhelpdesk.com/">
            <Button id="errorPage_helpButton">Visit Help Center</Button>
          </a>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Common/Error/ErrorDisplay.js